export default __webpack_public_path__ + "static/Nick Couture-ffa38d7131e1cee509795c51e4b3ed1c.jpg";